/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Reset_ButtonInputs */

const en_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const fr_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinitialiser`)
};

const de_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

const it_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const ru_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезагрузить`)
};

const es_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar`)
};

const zh_cn2_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置`)
};

const ja_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リセット`)
};

const hi_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रीसेट करें`)
};

const pt_pt2_tags_manager_reset_button = /** @type {(inputs: Tags_Manager_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Tags_Manager_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_reset_button = /** @type {((inputs?: Tags_Manager_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_reset_button(inputs)
	if (locale === "de") return de_tags_manager_reset_button(inputs)
	if (locale === "it") return it_tags_manager_reset_button(inputs)
	if (locale === "ru") return ru_tags_manager_reset_button(inputs)
	if (locale === "es") return es_tags_manager_reset_button(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_reset_button(inputs)
	if (locale === "ja") return ja_tags_manager_reset_button(inputs)
	if (locale === "hi") return hi_tags_manager_reset_button(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_reset_button(inputs)
	return en_tags_manager_reset_button(inputs)
});